import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import {
  ForestOutlined,
  KeyboardBackspace,
  TimeToLeaveOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  Skeleton,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { moment } from "../../App";
import { useDispatch } from "react-redux";
import { ENSDeclaration } from "./ENSDeclaration";
import { triggerRerender } from "../../common/CommonActions";
import { getVehicleCategoryIcon } from "../../common/VisualElementsHelper";

export function ClientTicketContent({
  data,
  loading,
  setData,
  readyForInvoice,
  checkIfLocked,
  invoiced,
  loadData,
  incompleteEditMode,
  readOnly,
}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [ensDeclarationDialog, setEnsDeclarationDialog] = useState(false);

  const openENSDeclarationDialog = () => {
    setEnsDeclarationDialog(true);
  };

  const closeENSDeclarationDialog = () => {
    setEnsDeclarationDialog(false);
    dispatch(triggerRerender());
    loadData();
  };

  const getVehicleCategory = () => {
    let category = "";
    if (data?.vehicleLength > 0 && data?.vehicleLength <= 6) {
      category = "Van";
    } else if (data?.vehicleLength == 7) {
      category = "Solo tractor";
    } else if (data?.vehicleLength > 7 && data?.vehicleLength < 15) {
      category = "Lorry";
    } else if (data?.vehicleLength >= 15 && data?.vehicleLength < 17) {
      category = "Artic";
    } else if (data?.vehicleLength >= 17 && data?.vehicleLength < 19) {
      category = "Road train";
    } else if (data?.vehicleLength >= 19) {
      category = "Train";
    }
    return category;
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
          ...theme.applyStyles("dark", {
            backgroundColor: theme.palette.primary.main,
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles("dark", {
        backgroundColor: "#39393D",
      }),
    },
  }));

  return (
    <>
      <Box sx={{ 
            // pointerEvents: readOnly ? "none" : "auto",
            "& .MuiInputBase-root.Mui-disabled": {
              backgroundColor: "transparent",
              "& input.Mui-disabled": {
                WebkitTextFillColor: "inherit",
                color: "inherit",
                opacity: 1,
              },
              "& fieldset": {
                borderColor: "rgba(0, 0, 0, 0.23)", 
              },
            },
            "& .MuiSwitch-root .Mui-disabled": {
              opacity: 1,
              "& + .MuiSwitch-track": {
                opacity: 1,
              },
            },
            "& .MuiFormLabel-root.Mui-disabled": {
              color: "inherit",
            },
          }}>
        <Grid container>
          {data ? (
            <>
              <Grid item md={12} style={{ textAlign: "right", paddingRight: 10 }}>
                {data?.productDestination?.ensDeclarationRequired && (
                  <div style={{ float: "right" }}>
                    <Button
                      disabled={data?.status == "REJECTED" || data?.status == "CANCELLED"}
                      variant="outlined"
                      color={
                        data.consignments && data?.consignments?.length > 0
                          ? "info"
                          : data?.consignments?.length > 0
                          ? "success"
                          : "warning"
                      }
                      startIcon={
                        data.consignments && data?.consignments?.length > 0 ? (
                          <Icon>info_outlined</Icon>
                        ) : data?.consignments?.length > 0 ? (
                          <Icon>done</Icon>
                        ) : (
                          <Icon>warning_amber</Icon>
                        )
                      }
                      onClick={() => openENSDeclarationDialog()}
                    >
                      ENS DECLARATION
                    </Button>
                  </div>
                )}
              </Grid>

              <Grid item xs={12} style={{ marginBottom: "5px", marginTop: "10px" }}>
                <Grid container spacing={2} style={{ padding: "0 10px 0 15px", color: theme.palette.lightGray.main }}>
                  <Grid item xs={2}>
                    <Typography variant="h6" style={{ textAlign: "left", fontWeight: "normal" }}>
                      {data?.assignedTo && "Assignee"}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}></Grid>
                  <Grid item xs={2}>
                    <Typography variant="h6" style={{ textAlign: "right", fontWeight: "normal" }}>
                      Booking Created
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ marginBottom: "10px" }}>
                <Grid container spacing={2} sx={{ padding: { xs: "0 0 0 15px", md: "0 10px 0 15px" }, color: theme.palette.lightGray.main }}>
                  <Grid item xs={5}>
                    <Typography variant="h4" style={{ textAlign: "left", color: theme.palette.darkContrast.main }} component="div">
                      {data?.assignedTo ? data?.assignedTo.firstName + " " + data?.assignedTo.lastName : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={6}>
                    <Typography sx={{ textAlign: "right", typography: { xs: "h5", md: "h4" } }}>
                      {moment(data?.dateCreated).format("DD.MM.YYYY HH:mm")}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={10} style={{ marginBottom: "5px" }}>
                <Grid container spacing={0.5} style={{ padding: "0 15px 0 15px" }}>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={2} md={3} lg={3}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main }}>
                          From
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6} lg={4}></Grid>
                      <Grid item xs={2} md={3} lg={3}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main }}>
                          To
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <Grid item xs={4} md={3}>
                        <Grid container>
                          <Grid item xs={3.5} lg={3} sx={{ marginRight: "5px" }}>
                            <ReactCountryFlag
                              countryCode={data?.fromCity?.country?.code}
                              svg
                              style={{ width: 24, height: 24, borderRadius: "6px", marginRight: "5px" }}
                              title={data?.fromCity?.country?.nameEn}
                            />
                          </Grid>
                          <Grid item xs={6} style={{ alignContent: "center" }}>
                            <Typography sx={{ typography: { xs: "h5", md: "h4" } }}>
                              {data?.fromCity?.name}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={6} lg={4} style={{ textAlign: "center", alignContent: "center" }}>
                        <KeyboardBackspace style={{ transform: "rotate(180deg)", fontSize: "30px" }} />
                      </Grid>
                      <Grid item xs={3}>
                        <Grid container>
                          <Grid item xs={3.5} lg={3} sx={{ marginRight: "5px" }}>
                            <ReactCountryFlag
                              countryCode={data?.toCity?.country?.code}
                              svg
                              style={{ width: 24, height: 24, borderRadius: "6px" }}
                              title={data?.toCity?.country?.nameEn}
                            />
                          </Grid>
                          <Grid item xs={3} md={6} style={{ alignContent: "center" }}>
                            <Typography sx={{ typography: { xs: "h5", md: "h4" } }}>
                              {data?.toCity?.name}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1} style={{ padding: "0 15px 0 15px" }}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={6} md={4}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main, marginBottom: "5px" }}>
                          Departure Date
                        </Typography>
                        <Typography variant="h5" style={{ fontWeight: "bold", color: theme.palette.darkContrast.main }}>
                          {moment(data?.departureDay).format("DD.MM.YYYY")}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        <Typography variant="h6" sx={{ fontWeight: "normal", color: theme.palette.lightGray.main, textAlign: { xs: "right", md: "left" }, marginBottom: "5px" }}>
                          Departure Hour
                        </Typography>
                        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.darkContrast.main, textAlign: { xs: "right", md: "left" } }}>
                          {data?.departureHour}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={4}>
                        {data?.organization?.showSupplier && (
                          <Typography variant="h6" sx={{ fontWeight: "normal", color: theme.palette.lightGray.main, textAlign: { xs: "left", md: "right" }, marginBottom: "5px" }}>
                            Supplier
                          </Typography>
                        )}
                        {data?.organization?.showSupplier && (
                          <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.darkContrast.main, textAlign: { xs: "left", md: "right" } }}>
                            {data?.productDestination?.operator?.name
                              ? data?.productDestination?.operator?.name
                              : data?.productDestination?.supplier?.name}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ padding: "10px" }}>
                <Divider />
              </Grid>

              <Grid item xs={12}>
                <Grid container p={1}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main, marginBottom: "5px" }}>
                      Vehicle Category
                    </Typography>
                    <TextField
                      variant="outlined"
                      value={data?.vehicleCategory?.name || getVehicleCategory()}
                      sx={{ width: { md: "95%", xs: "100%" } }}
                      size="small"
                      InputProps={{
                        readOnly: !incompleteEditMode,
                        style: { color: theme.palette.darkContrast.main, fontSize: "15px", fontWeight: "bold" },
                        startAdornment: (
                          <InputAdornment position="start" style={{ color: theme.palette.darkContrast.main }}>
                            {getVehicleCategoryIcon(
                              data?.vehicleCategory || {
                                minLength: data?.vehicleLength,
                                maxLength: data?.vehicleLength,
                              },
                              { fontSize: "20px" },
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={4} md={2}>
                    <Typography variant="h6" sx={{ fontWeight: "normal", color: theme.palette.lightGray.main, marginBottom: "5px" }}>
                      Length
                    </Typography>
                    <TextField
                      variant="outlined"
                      value={data?.vehicleLength || ""}
                      style={{ width: "95%" }}
                      size="small"
                      InputProps={{
                        readOnly: !incompleteEditMode,
                        endAdornment: (
                          <InputAdornment position="end">
                            <span style={{ color: theme.palette.darkContrast.main, opacity: "25%" }}>m</span>
                          </InputAdornment>
                        ),
                        sx: { color: theme.palette.darkContrast.main, fontSize: "15px", fontWeight: "bold", input: { textAlign: "center" } },
                      }}
                      onChange={(e) => incompleteEditMode && setData({ ...data, vehicleLength: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={4} md={2}>
                    <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main, marginBottom: "5px" }}>
                      Width
                    </Typography>
                    <TextField
                      variant="outlined"
                      value={data?.vehicleWidth || ""}
                      style={{ width: "95%" }}
                      size="small"
                      InputProps={{
                        readOnly: !incompleteEditMode,
                        endAdornment: (
                          <InputAdornment position="end">
                            <span style={{ color: theme.palette.darkContrast.main, opacity: "25%" }}>m</span>
                          </InputAdornment>
                        ),
                        sx: { color: theme.palette.darkContrast.main, fontSize: "15px", fontWeight: "bold", input: { textAlign: "center" } },
                      }}
                      onChange={(e) => incompleteEditMode && setData({ ...data, vehicleWidth: e.target.value })}
                    />
                  </Grid>
                  <Grid item xs={4} md={2}>
                    <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main, marginBottom: "5px" }}>
                      Height
                    </Typography>
                    <TextField
                      variant="outlined"
                      value={data?.vehicleHeight || ""}
                      style={{ width: "95%", display: "flex" }}
                      size="small"
                      InputProps={{
                        readOnly: !incompleteEditMode,
                        endAdornment: (
                          <InputAdornment position="start">
                            <span style={{ color: theme.palette.darkContrast.main, opacity: "25%" }}>m</span>
                          </InputAdornment>
                        ),
                        sx: { color: theme.palette.darkContrast.main, fontSize: "15px", fontWeight: "bold", input: { textAlign: "center" } },
                      }}
                      onChange={(e) => incompleteEditMode && setData({ ...data, vehicleHeight: e.target.value })}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ padding: "10px" }}>
                <Divider />
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2} style={{ padding: "0 15px 0 15px" }}>
                  <Grid item xs={6}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Truck Plate Number"
                      value={data?.truckPlateNumber || ""}
                      onChange={(e) => incompleteEditMode && setData({ ...data, truckPlateNumber: e.target.value })}
                      InputProps={{ readOnly: !incompleteEditMode }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    {(incompleteEditMode || data?.trailerPlateNumber) && (
                      <TextField
                        size="small"
                        fullWidth
                        label="Trailer Plate Number"
                        value={data?.trailerPlateNumber || ""}
                        onChange={(e) => incompleteEditMode && setData({ ...data, trailerPlateNumber: e.target.value })}
                        InputProps={{ readOnly: !incompleteEditMode }}
                      />
                    )}
                  </Grid>
                  {data?.mrn && (
                    <Grid item xs={6}>
                      <TextField
                        size="small"
                        fullWidth
                        label="MRN"
                        value={data?.mrn}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ padding: "10px" }}>
                <Divider />
              </Grid>

              <Grid item xs={6} style={{ marginBottom: "10px" }}>
                <Grid container style={{ padding: "0 15px 0 15px" }}>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Driver Full Name"
                      value={data?.driverName || ""}
                      onChange={(e) => incompleteEditMode && setData({ ...data, driverName: e.target.value })}
                      InputProps={{ readOnly: !incompleteEditMode }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={6} style={{ marginBottom: "10px" }}>
                <Grid container style={{ padding: "0 15px 0 15px" }}>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Customer Reference Number"
                      value={data?.customerReferenceNumber || ""}
                      onChange={(e) => incompleteEditMode && setData({ ...data, customerReferenceNumber: e.target.value })}
                      InputProps={{ readOnly: !incompleteEditMode }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              { data?.releaseCode !== null && 
                data?.product?.sendReleaseCode === true &&
                (
               <Grid item xs={6} style={{ marginBottom: "10px" }}>
                <Grid container style={{ padding: "5px 15px 0 15px" }}>
                  <Grid item xs={12}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Release Code"
                      value={data?.releaseCode || ""}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                </Grid>
              </Grid>)}

              <Grid item xs={12} style={{ padding: "0 10px 0px 10px" }}>
                <Divider />
              </Grid>

              <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                <Grid container spacing={2} style={{ padding: "0 15px 0 15px" }}>
                  <Grid item xs={12}>
                    <Grid container spacing={1} style={{ marginTop: "5px" }}>
                      <Grid item md={5} lg={4} xl={3}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main, marginBottom: "5px" }}>
                          Cargo Type
                        </Typography>
                        <TextField
                          variant="outlined"
                          disabled
                          value={data?.loaded && data?.material?.name ? data?.material?.name : "UNKNOWN"}
                          inputProps={{ readOnly: !incompleteEditMode }}
                          onChange={(e) => incompleteEditMode && setData({ ...data, material: { ...data?.material, name: e.target.value } })}
                          InputProps={{
                            style: { color: theme.palette.darkContrast.main, fontSize: "15px", fontWeight: "bold" },
                            startAdornment: (
                              <InputAdornment position="start" style={{ color: theme.palette.darkContrast.main }}>
                                {data?.material?.name == "Cars" ? (
                                  <TimeToLeaveOutlined style={{ fontSize: "20px" }} />
                                ) : data?.material?.name == "Paper" ? (
                                  <Icon style={{ fontSize: "20px" }}>
                                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="M16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0V14H0V17C0 18.66 1.34 20 3 20H15C16.66 20 18 18.66 18 17V0L16.5 1.5ZM12 18H3C2.45 18 2 17.55 2 17V16H12V18ZM16 17C16 17.55 15.55 18 15 18C14.45 18 14 17.55 14 17V14H5V3H16V17Z"
                                        fill="#202020"
                                      />
                                    </svg>
                                  </Icon>
                                ) : data?.material?.name == "Wood" ? (
                                  <ForestOutlined style={{ fontSize: "20px" }} />
                                ) : data?.material?.name == "Metal" ? (
                                  <Icon style={{ fontSize: "20px" }}>
                                    <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                        d="M4.5 4.5H1V1H14V4.5H10.5H9.5V5.5V14.5V15.5H10.5H14V19H1V15.5H4.5H5.5V14.5V5.5V4.5H4.5Z"
                                        stroke="#202020"
                                        strokeWidth="2"
                                      />
                                    </svg>
                                  </Icon>
                                ) : (
                                  ""
                                )}
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item md={3} lg={2} xl={1.5}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main, marginBottom: "5px" }}>
                          Weight
                        </Typography>
                        <TextField
                          variant="outlined"
                          value={data?.cargoWeight || ""}
                          onChange={(e) => incompleteEditMode && setData({ ...data, cargoWeight: e.target.value })}
                          InputProps={{
                            readOnly: !incompleteEditMode,
                            endAdornment: (
                              <InputAdornment position="end">
                                <span style={{ color: theme.palette.darkContrast.main, opacity: "25%" }}>
                                  {data?.loaded && "t"}
                                </span>
                              </InputAdornment>
                            ),
                            sx: { color: theme.palette.darkContrast.main, fontSize: "15px", fontWeight: "bold", input: { textAlign: "center" } },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sx={{ paddingBottom: data?.ticketAttachments ? "10px" : "0px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={4} md={3}>
                    <Grid container spacing={2} style={{ padding: "0 15px 0 15px", marginTop: "-10px" }}>
                      <Grid item xs={12}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main }}>
                          Dangerous Goods
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <IOSSwitch
                          checked={data?.dangerousGoods || false}
                          onChange={(e) => incompleteEditMode && setData({ ...data, dangerousGoods: e.target.checked })}
                          disabled={!incompleteEditMode}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={4} md={3}>
                    <Grid container spacing={2} style={{ padding: "0 15px 0 15px", marginTop: "-10px" }}>
                      <Grid item xs={12}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main }}>
                          Electric Plugin
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <IOSSwitch
                          checked={data?.electricPlugin || false}
                          onChange={(e) => incompleteEditMode && setData({ ...data, electricPlugin: e.target.checked })}
                          disabled={!incompleteEditMode}
                        />
                      </Grid>
                      <Grid item xs={12} md={3} sx={{ display: "flex", alignContent: "center", marginTop: "3px" }}>
                        {data?.temperature && (
                          <Typography variant="h4" sx={{ display: "inline-block", color: theme.palette.lightGray.main, fontWeight: "light", marginBottom: "5px" }}>
                            {data.temperature}°C
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={4} md={2}>
                    <Grid container spacing={2} sx={{ padding: "0 15px 0 15px", marginTop: { xs: "0px", md: "-10px" } }}>
                      <Grid item xs={12}>
                        <Typography variant="h6" style={{ fontWeight: "normal", color: theme.palette.lightGray.main }}>
                          Live Animals
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <IOSSwitch
                          checked={data?.liveAnimals || false}
                          onChange={(e) => incompleteEditMode && setData({ ...data, liveAnimals: e.target.checked })}
                          disabled={!incompleteEditMode}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {data?.missingMandatorySurcharge && (
                    <Grid item xs={12} md={4}>
                      <Grid container spacing={2} sx={{ padding: "0 15px 0 15px", marginTop: { xs: "0px", md: "-10px" } }}>
                        <Grid item xs={12}>
                          <Box display="flex" alignItems="center" bgcolor={theme.palette.warning.main} color={theme.palette.warning.contrastText} p={1} borderRadius={2}>
                            <Icon sx={{ mr: 1 }}>credit_card_off</Icon>
                            <Typography variant="subtitle1" fontWeight={600}>
                              Mandatory surcharge(s) currently not applied and will be added later.
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ padding: "20px 10px 5px 10px" }}></Grid>
            </>
          ) : (
            <>
              <Grid item xs={12} style={{ padding: "0 20px 0 20px" }}><Skeleton height={100} /></Grid>
              <Grid item xs={12} style={{ padding: "0 20px 0 20px" }}><Skeleton height={100} /></Grid>
              <Grid item xs={12} style={{ padding: "0 20px 0 20px" }}><Skeleton height={100} /></Grid>
              <Grid item xs={12} style={{ padding: "0 20px 0 20px" }}><Skeleton height={100} /></Grid>
              <Grid item xs={12} style={{ padding: "0 20px 0 20px" }}><Skeleton height={100} /></Grid>
              <Grid item xs={12} style={{ padding: "0 20px 0 20px" }}><Skeleton height={100} /></Grid>
              <Grid item xs={12} style={{ padding: "0 20px 0 20px" }}><Skeleton height={100} /></Grid>
            </>
          )}
        </Grid>
      </Box>

      <Dialog open={ensDeclarationDialog} fullScreen fullWidth sx={{ padding: 5 }}>
        <DialogTitle style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", fontSize: "20px" }}>
            <Icon color="primary" fontSize="large">assignment</Icon>
            <span style={{ marginLeft: 8, color: "#323232", lineHeight: "1.2em" }}>
              ENS Declaration - {data?.reservationCode}
            </span>
          </div>
          <IconButton onClick={closeENSDeclarationDialog} disabled={loading}>
            <Icon fontSize="medium">close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ENSDeclaration
            data={data}
            ensDeclarationDialog={ensDeclarationDialog}
            loadData={loadData}
            loadingData={loading}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
